import { IconName } from '@utilities/icon';
import RateCard, { RateCardProps } from '../rateCard/rateCard';
import dynamic from 'next/dynamic';

const ShimmerRateCard = dynamic(() => import('../rateCard/shimmer'), {
  loading: () => <ShimmerRateCard />,
});

interface DoctorRatingProps {
  cards: RateCardProps[];
}
const DoctorRating = ({ cards }: DoctorRatingProps) => {
  return (
    <div className="flex justify-center w-full mb-2">
      <div className="flex justify-between items-stretch w-full px-4 gap-x-2">
        {cards?.map((card) => (
          <div key={card.label} className="flex-1 flex justify-center h-full">
            <RateCard
              iconName={card.iconName as IconName}
              iconColor={card.iconColor}
              text={card.text}
              label={card.label}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DoctorRating;
